import { useFormik } from "formik";
import { useEffect } from "react";

// Internal Imports
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import Paint from "../../../common/components/Paint/Paint";
import { COLORS } from "../../../common/constants/colors";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import { useListDepartmentByUer } from "../../../hooks/useListDepartment";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { fakeListBase } from "../../../common/constants/Utilities";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}

const StepOne = ({ setCanGoNext, mode }: Props) => {

    // States
    const { listDepartment, loadingDeparment } = useListDepartmentByUer();
    const { setListBaseForm, listBaseForm } = useForm();

    // Methods
    const validations = (values: any) => {
        const errors: any = {};

        if (!values.nombre) {
            errors.nombre = "Requerido";
        }

        if (!values.departamentoGUID) {
            errors.departamentoGUID = "Requerido";
        }

        return errors;
    }

    // Form
    const ListBaseFormik = useFormik({
        initialValues: { nombre: "", departamentoGUID: "" },
        validate: validations,
        onSubmit: (values: any) => console.log(values),
    });


    useEffect(() => {
        ListBaseFormik.validateForm().then((response) => {
            if (!!listBaseForm) {
                ListBaseFormik.setValues({
                    nombre: !!listBaseForm.nombre ? listBaseForm.nombre : "",
                    departamentoGUID: listBaseForm.departamentoGUID,
                });
            }

            if (JSON.stringify(response) == '{}') {
                setCanGoNext(true);
            } else {
                setCanGoNext(false);
            }
        });
    }, [])


    useEffect(() => {
        if (!!listBaseForm) {
            setListBaseForm({
                ...listBaseForm!,
                nombre: ListBaseFormik.values.nombre,
                departamentoGUID: ListBaseFormik.values.departamentoGUID
            });
        } else {
            setListBaseForm({ ...fakeListBase, listadoAtributo: [] });
        }

        if (JSON.stringify(ListBaseFormik.errors) == '{}') {
            setCanGoNext(true);
        } else {
            setCanGoNext(false);
        }
    }, [ListBaseFormik.values, ListBaseFormik.isValid]);

    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="100%">
                    <label>Nombre:</label>
                    <EditTextForm
                        value={ListBaseFormik.values.nombre}
                        onChange={ListBaseFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"nombre"}
                        placeholder={"Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.nombre && ListBaseFormik.errors.nombre}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="100%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={ListBaseFormik.values.departamentoGUID}
                        defaultValue={listBaseForm?.departamentoGUID}
                        placeholder={"Departamento"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => ListBaseFormik.setFieldValue("departamentoGUID", value)}
                        options={listDepartment.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoGUID, text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.departamentoGUID && ListBaseFormik.errors.departamentoGUID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>
        </div>
    );
}

export default StepOne;